import React from 'react';
import { Youtube, Instagram, Mail, ExternalLink } from 'lucide-react';
import { socialLinks } from '../data/mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-blue-950 to-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_flashcards-direito/artifacts/8s6fjaif_logo-canal.jpg" 
              alt="Direito em 5 Minutos" 
              className="h-16 w-auto object-contain mb-6"
            />
            <p className="text-gray-300 mb-6 leading-relaxed">
              Simplificamos o Direito para você acelerar sua aprovação. 
              Flashcards inteligentes com método comprovado para concursos públicos e OAB.
            </p>
            
            {/* Social Links - Destacado */}
            <div className="space-y-3">
              <p className="font-bold text-orange-400 mb-3">Acompanhe nosso conteúdo gratuito:</p>
              <a 
                href={socialLinks.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 bg-red-600 hover:bg-red-700 px-4 py-3 rounded-lg transition-all duration-300 transform hover:scale-105"
              >
                <Youtube size={24} />
                <div>
                  <div className="font-semibold">YouTube</div>
                  <div className="text-xs text-gray-200">Aulas gratuitas diárias</div>
                </div>
                <ExternalLink size={16} className="ml-auto" />
              </a>
              
              <a 
                href={socialLinks.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 px-4 py-3 rounded-lg transition-all duration-300 transform hover:scale-105"
              >
                <Instagram size={24} />
                <div>
                  <div className="font-semibold">Instagram</div>
                  <div className="text-xs text-gray-200">Dicas rápidas de aprovação</div>
                </div>
                <ExternalLink size={16} className="ml-auto" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-orange-400">Links Rápidos</h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('produtos')}
                  className="text-gray-300 hover:text-orange-400 transition-colors"
                >
                  Nossos Produtos
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('como-funciona')}
                  className="text-gray-300 hover:text-orange-400 transition-colors"
                >
                  Como Funciona
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('conteudo-gratuito')}
                  className="text-gray-300 hover:text-orange-400 transition-colors"
                >
                  Conteúdo Gratuito
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('depoimentos')}
                  className="text-gray-300 hover:text-orange-400 transition-colors"
                >
                  Depoimentos
                </button>
              </li>
            </ul>
          </div>

          {/* Disciplines */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-orange-400">Disciplinas</h3>
            <ul className="space-y-3 text-gray-300 text-sm">
              <li>Lei de Execução Penal</li>
              <li>Direito Constitucional</li>
              <li>Direito Administrativo</li>
              <li>Direito Penal</li>
              <li>Processo Penal</li>
              <li>Direito Civil</li>
              <li>Processo Civil</li>
              <li>Ética - OAB</li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            {/* Copyright */}
            <div className="text-gray-400 text-sm">
              © {currentYear} Direito em 5 Minutos. Todos os direitos reservados.
            </div>

            {/* Trust Badges */}
            <div className="flex items-center space-x-6 text-sm text-gray-400">
              <div className="flex items-center space-x-2">
                <span className="text-orange-400">✓</span>
                <span>Pagamento Seguro</span>
              </div>
              <div className="flex items-center space-x-2">
                <span className="text-orange-400">✓</span>
                <span>Acesso Imediato</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-black/30 py-4">
        <div className="container mx-auto px-4 text-center">
          <p className="text-gray-400 text-sm">
            Desenvolvido com 💙 para concurseiros que querem ser aprovados
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
